import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { COLORS } from '../../../assets/js/constants';
import { FONTS } from '../../../tokens/fonts';

const defaultProps = {
    onClick: () => {
        return;
    },
};

const propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string,
};

const AccordionHeader = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    user-select: none;
    width: 100%;
`;

const AccordionHeaderText = styled.span`
    border-bottom: 1px dotted ${COLORS.blue};
    color: ${COLORS.blue};
    display: inline-block;
    ${FONTS.S};
`;

const AccordionHeaderIcon = styled.img`
    margin-left: 10px;
    transform: ${({ isShow }) => isShow ? 'rotate(-180deg)' : 'rotate(0deg)'};
    transform-origin: 50% 50%;
    transition: transform 0.3s ease;
    height: 7px;
    width: 12px;
`;

export function AccordionAnimateHeader(props) {
    let headerContent = props.children;

    if (props.text !== undefined) {
        headerContent = (
            <React.Fragment>
                <AccordionHeaderText data-test={'AccordionHeaderText'}>{props.text}</AccordionHeaderText>
                <AccordionHeaderIcon data-test={'AccordionHeaderIcon'} isShow={props.isShow} src={require('./image/bottom.svg')} alt='bottomIcon' />
            </React.Fragment>
        );
    }

    return (
        <AccordionHeader onClick={props.onClick} {...props}>
            {headerContent}
        </AccordionHeader>
    );
}

AccordionAnimateHeader.defaultProps = defaultProps;
AccordionAnimateHeader.propTypes = propTypes;
